import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/Accordion';
const FAQS = [{
  question: 'What areas do you serve?',
  answer: 'Phoenix, Casa Grande, and Tucson (and nearby areas depending on the job).'
}, {
  question: 'Do you offer same-day service?',
  answer: 'Yes. We prioritize same-day appointments whenever possible, and next-day scheduling when same-day slots are full.'
}, {
  question: 'Can I get an estimate over the phone?',
  answer: 'Often yes. For complex issues, we may need an on-site evaluation first.'
}];
export function Faq() {
  return <section id="faq" className="w-full bg-white" data-id="element-33" data-mp="240fbhx0ob1ts">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-20 sm:px-6 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-34" data-mp="1z3ow7bwp0a9f">
        <div data-id="element-35" data-mp="snd5fvw79unv">
          <span className="text-sm font-semibold uppercase tracking-wide text-sky-600" data-id="element-36" data-mp="snwf6pbp5cqt">FAQ</span>
          <h2 className="mt-2 font-heading text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-37" data-mp="nn8ok4rdqxx4">
            Frequently asked questions
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-38" data-mp="ugr5glu2kghe">
            Get the details you need before scheduling your service.
          </p>
        </div>

        <Accordion type="single" defaultValue="faq-0" className="rounded-2xl border border-slate-200 bg-white px-6" data-id="element-39" data-mp="fj8gpjhe639y">
          {FAQS.map((faq, index) => <AccordionItem key={faq.question} value={`faq-${index}`} data-id="element-40" data-mp="6qwu68peezz9" data-mpi={index}>
              <AccordionTrigger className="text-left font-heading text-base font-semibold text-slate-900 hover:no-underline" data-id="element-41" data-mp="6plno14kje4g">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="pr-8 text-sm leading-relaxed text-slate-600" data-id="element-42" data-mp="3swk0p96z11rm">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}